import { render, staticRenderFns } from "./customer-profile.vue?vue&type=template&id=28a33ee4&scoped=true&"
import script from "./customer-profile.vue?vue&type=script&lang=js&"
export * from "./customer-profile.vue?vue&type=script&lang=js&"
import style0 from "./customer-profile.vue?vue&type=style&index=0&id=28a33ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a33ee4",
  null
  
)

export default component.exports